// src/components/DecisionalModel1/index.jsx
import React, { useCallback, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import GRAIEditor from "../GRAIEditor";
import "./DecisionalModel1.css";

function DecisionalModel1(props) {
  const history = useHistory();
  const [downloading, setDownloading] = useState(false);
  const [message, setMessage] = useState("");

  // PDF haute qualité + redirection
  const handleDownloadPDF = useCallback(async () => {
    try {
      const element = document.querySelector(".decisional-model-1-1");
      if (!element) {
        alert("Error: Unable to find the content to export!");
        return;
      }

      setDownloading(true);
      window.scrollTo(0, 0);

      const canvas = await html2canvas(element, {
        scale: 2.5,
        backgroundColor: "#ffffff",
        useCORS: true,
        logging: false,
        scrollX: 0,
        scrollY: 0,
        windowWidth: document.documentElement.scrollWidth,
        windowHeight: document.documentElement.scrollHeight,
      });

      const imgData = canvas.toDataURL("image/png", 1.0);
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      let position = 0;
      const pageHeight = pdf.internal.pageSize.getHeight();

      while (position < pdfHeight) {
        pdf.addImage(imgData, "PNG", 0, -position, pdfWidth, pdfHeight);
        position += pageHeight;
        if (position < pdfHeight) pdf.addPage();
      }

      pdf.save("decisional-model.pdf");

      setDownloading(false);
      setMessage("✅ PDF automatically saved to your Downloads folder!");

      setTimeout(() => {
        history.push("/informational-model-1");
      }, 1500);
    } catch (err) {
      console.error("Error generating PDF:", err);
      alert("Error during PDF generation.");
      setDownloading(false);
    }
  }, [history]);

  const handleDownloadPDF2 = useCallback(async () => {
    try {
      const element = document.querySelector(".decisional-model-1-1");
      if (!element) {
        alert("Error: Unable to find the content to export!");
        return;
      }

      setDownloading(true);
      window.scrollTo(0, 0);

      const canvas = await html2canvas(element, {
        scale: 2.5,
        backgroundColor: "#ffffff",
        useCORS: true,
        logging: false,
        scrollX: 0,
        scrollY: 0,
        windowWidth: document.documentElement.scrollWidth,
        windowHeight: document.documentElement.scrollHeight,
      });

      const imgData = canvas.toDataURL("image/png", 1.0);
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      let position = 0;
      const pageHeight = pdf.internal.pageSize.getHeight();

      while (position < pdfHeight) {
        pdf.addImage(imgData, "PNG", 0, -position, pdfWidth, pdfHeight);
        position += pageHeight;
        if (position < pdfHeight) pdf.addPage();
      }

      pdf.save("decisional-model.pdf");

      setDownloading(false);
      setMessage("✅ PDF automatically saved to your Downloads folder!");

      setTimeout(() => {
        history.push("/conception");
      }, 1500);
    } catch (err) {
      console.error("Error generating PDF:", err);
      alert("Error during PDF generation.");
      setDownloading(false);
    }
  }, [history]);

  return (
    <div className="container-center-horizontal">
      <div className="decisional-model-1-1 screen">
        <div className="decisional-model-content">
          <GRAIEditor
            instanceId="grai_decisional"
            storageKey="graiGridData_decisional"
            title="Decisional Model – GRAI Grid"
          />
        </div>
      </div>

      {message && (
        <p
          style={{
            textAlign: "center",
            color: message.startsWith("✅") ? "green" : "black",
            marginTop: "10px",
            fontWeight: 500,
          }}
        >
          {message}
        </p>
      )}

      <div className="icam-navigation">
        <Link to="/physical-model-1">
          <button className="icam-nav-btn">Back</button>
        </Link>

        <Link to="/informational-model-1">
          <button className="icam-nav-btn">Continue</button>
        </Link>
      </div>
    </div>
  );
}

export default DecisionalModel1;
